import { useEffect } from "react";

interface PageMeta {
  title: string;
  description?: string;
  keywords?: string;
}

const setMeta = (name: string, content: string) => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export default function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    document.title = title;
    if (description) setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);
    return () => {
      // 恢复首页 TDK
      document.title = "电影天堂－最新电影推荐与影视资源分享平台";
      setMeta(
        "description",
        "电影天堂提供海量最新影视资源，涵盖各类电影类型，方便用户查找和浏览，打造优质影视内容分享平台。",
      );
      setMeta(
        "keywords",
        "电影天堂,最新电影,影视资源,电影推荐,电影下载,电影资讯,高清电影",
      );
    };
  }, [title, description, keywords]);
}